module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedBlack.ad9867b.ttf";